<template>
  <v-container :class="{'px-1': $vuetify.breakpoint.smAndDown}" my-1>
    <v-flex xs12 class="text-xs-center">
      <v-layout row wrap>
        <v-flex xs12 class="text-xs-center">
          <h2>Rutas lote {{batch}}</h2>
        </v-flex>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="routes"
            class="elevation-1"
            hide-actions
            no-data-text="No hay informacion que mostrar"
            v-bind:pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td>
                <a @click="wantUpdate(props.item)">
                {{ props.item.description }}
                </a>
              </td>
              <td>{{ props.item.real_date | formatDate}}</td>
              <td v-if="show_payed_price" class="text-xs-right">{{ props.item.material_expenses | currency }}</td>
              <td  class="text-xs-right">{{ props.item.summary.catalyst ? props.item.summary.catalyst.payed_price: 0.00 | currency}}</td>
              <td class="text-xs-right">{{ props.item.summary.catalyst ? props.item.summary.catalyst.subtotal_d_list_price: 0.00 | currency}}</td>
              <td class="text-xs-right"  v-if="hasRole('SHOW_DOLLAR')">
                {{ props.item.summary.catalyst ? props.item.summary.catalyst.subtotal_return_us: 0.00 | currency}}
              </td>
              <td class="text-xs-right"  v-if="hasRole('SHOW_DOLLAR')">
                {{ props.item.summary.catalyst ? props.item.summary.catalyst.subtotal_dollar_price: 0.00 | currency}}
              </td>
              <td class="text-xs-right" >{{ props.item.viatic_expenses | currency }}</td>
              <td class="text-xs-right" >{{ props.item.comission_expenses | currency }}</td>
              <td class="text-xs-right">{{ props.item.pounds }}</td>
              <td v-if="props.item.summary.catalyst" class="text-xs-right">{{props.item.summary.catalyst ? props.item.summary.catalyst.pieces: 0.0}} ({{props.item.summary.catalyst ? props.item.summary.catalyst.real_pieces: 0.00}})</td>
              <td v-else class="text-xs-right">0 (0)</td>
              <td v-if="props.item.summary.top" class="text-xs-right">{{ props.item.summary.top.tops | currency('') }}</td>
              <td v-else class="text-xs-right">0.00</td>
              <td v-if="props.item.summary.top" class="text-xs-right">{{ props.item.summary.top.pieces_per_kilo | currency('') }}</td>
              <td v-else class="text-xs-right">0.00</td>
              <td v-if="show_metal_information">{{ getformatedMetalValues(props.item, 'IL') }}</td>
              <td v-if="show_metal_information">{{ getformatedMetalValues(props.item, 'IM') }}</td>
              <td v-if="show_metal_information">{{ getformatedMetalValues(props.item, 'IS') }}</td>
              <td v-if="show_metal_information">{{ getformatedMetalValues(props.item, 'LL') }}</td>
              <td v-if="show_metal_information">{{ getformatedMetalValues(props.item, 'LM') }}</td>
              <td v-if="show_metal_information">{{ getformatedMetalValues(props.item, 'LS') }}</td>
            </template>
            <template slot="footer">
              <tr>
                <td ><strong >Totales</strong></td>
                <td class="text-xs-right"><strong >&nbsp;</strong></td>
                <td  v-if="show_payed_price" class="text-xs-right"><strong >{{ totals.material_expenses | currency }}</strong></td>
                <td class="text-xs-right"><strong >{{ totals.summary_catalyst_payed_price | currency }}</strong></td>
                <td class="text-xs-right"><strong >{{ totals.summary_catalyst_subtotal_d_list_price | currency }}</strong></td>
                <td class="text-xs-right" v-if="hasRole('SHOW_DOLLAR')">
                  <strong >{{ totals.summary_catalyst_subtotal_return_us | currency }}</strong>
                </td>
                <td class="text-xs-right" v-if="hasRole('SHOW_DOLLAR')">
                  <strong >{{ totals.summary_catalyst_subtotal_dollar_price | currency }}</strong>
                </td>
                 
                <td class="text-xs-right"><strong >{{ totals.viatic_expenses | currency }}</strong></td> 
                <td class="text-xs-right"><strong >{{ totals.comission_expenses | currency }}</strong></td> 
                <td class="text-xs-right"><strong >{{ totals.pounds | currency('', 2)}}</strong></td>
                <td class="text-xs-right"><strong >{{ totals.summary_catalyst_pieces | currency('', 2)}} ({{totals.summary_catalyst_real_pieces | currency('', 2)}})</strong></td>
                <td class="text-xs-right"><strong >{{ totals.summary_top_tops | currency('', 2) }}</strong></td>
                <td class="text-xs-right"><strong >{{ totals.summary_top_pieces_per_kilo | currency('', 2) }}</strong></td>
                <td class="text-xs-right" v-if="show_metal_information"><strong >{{ totals.il_metal[0] | currency('', 2) }} ({{ totals.il_metal[1] | currency('', 2) }})</strong></td>
                <td class="text-xs-right" v-if="show_metal_information"><strong >{{ totals.im_metal[0] | currency('', 2) }} ({{ totals.im_metal[1] | currency('', 2) }})</strong></td>
                <td class="text-xs-right" v-if="show_metal_information"><strong >{{ totals.is_metal[0] | currency('', 2) }} ({{ totals.is_metal[1] | currency('', 2) }})</strong></td>
                <td class="text-xs-right" v-if="show_metal_information"><strong >{{ totals.ll_metal[0] | currency('', 2) }} ({{ totals.ll_metal[1] | currency('', 2) }})</strong></td>
                <td class="text-xs-right" v-if="show_metal_information"><strong >{{ totals.lm_metal[0] | currency('', 2) }} ({{ totals.lm_metal[1] | currency('', 2) }})</strong></td>
                <td class="text-xs-right" v-if="show_metal_information"><strong >{{ totals.ls_metal[0] | currency('', 2) }} ({{ totals.ls_metal[1] | currency('', 2) }})</strong></td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12></v-flex>
      </v-layout>
    </v-flex>
  </v-container>
</template>
<script>
export default {
  props: ['batch', 'updatedRoute'],
  data() {
    return {
      headers: [
        { text: 'Ruta', value: 'description' },
        { text: 'Fecha Ruta', value: 'real_date' },
        { text: 'G. Piezas', value: 'material_expenses' },
        { text: 'P. Pagado', value: 'summary_catalyst_payed_price' },
        { text: 'Lista D', value: 'summary_catalyst_subtotal_d_list_price' },
        { text: 'Valor al 100%', value: 'summary_catalyst_subtotal_return_us',  type: 'dollar'},
        { text: 'menos gastos op.', value: 'summary_catalyst_subtotal_dollar_price',  type: 'dollar'},
        { text: 'Viaticos', value: 'viatic_expenses' },
        { text: 'Comisión', value: 'comission_expenses'},
        { text: 'Libras', value: 'pounds' },
        { text: 'Piezas', sortable: false },
        { text: 'Tops', sortable: false },
        { text: 'Piezas X Kilo', sortable: false },
        { text: 'Imp. Grande', sortable: false, type: 'metal' },
        { text: 'Mediano', sortable: false, type: 'metal' },
        { text: 'Chico', sortable: false, type: 'metal' },
        { text: 'Dom. Grande', sortable: false, type: 'metal' },
        { text: 'Mediano', sortable: false, type: 'metal' },
        { text: 'Chico', sortable: false, type: 'metal' },
      ],
      pagination: {sortBy: 'id', descending: true, rowsPerPage: -1},
      routes: [],
      show_payed_price: false,    // For development, allow to easily switch between show or hide this particular field
      show_metal_information: false,
      current_batch: {},
    };
  },
  watch: {
    updatedRoute: {
      handler(newValue, oldValue) {
        const objIndex = this.routes.findIndex((route) => route.id === newValue.id);
        const newRow = Object.assign(this.routes[objIndex], newValue);
        this.$set(this.routes, objIndex, newRow); // https://vuejs.org/2016/02/06/common-gotchas/
      },
      deep: true,
    },
  },

  methods: {
    retrieveRoutesForCurrentBatch() {
      this.axios
        .get(`/batch/${this.batch}/routes`)
        .then((results) => {
          this.routes = results.data;
        })
        .catch((error) => {
          this.$emit('error', error.message);
        });
    },
    retrieveCurrentBatch() {
      this.axios
        .get(`/batch/${this.batch}`)
        .then((results) => {
          this.current_batch = results.data;
        })
        .catch((error) => {
          this.$emit('error', error.message);
        });

    },

    wantUpdate(route) {
      this.$emit('update-route', route);
    },

    getStatusTranslation(status) {
      if (status === 'OPEN') {
        return 'Abierto';
      } else if (status === 'CLOSE') {
        return 'Cerrado';
      }
      return '';
    },

    /**
     * Returns the array of the metal values
     *    [Pieces, Real pieces]
     */
    getPairMetalValues(item, type) {
      if (!item.summary || !item.summary.metal) {
        return [0, 0];
      }
      let result = [];
      if (type === 'IL') {
        result = this.getImportedLargeValues(item);
      }
      if (type === 'IM') {
        result = this.getImportedMediumValues(item);
      }
      if (type === 'IS') {
        result = this.getImportedSmallValues(item);
      }
      if (type === 'LL') {
        result = this.getLocalLargeValues(item);
      }
      if (type === 'LM') {
        result = this.getLocalMediumValues(item);
      }
      if (type === 'LS') {
        result = this.getLocalSmallValues(item);
      }
      return result;
    },

    /**
     * Returns the string of the metal values
     *    Piezes ([Real piezes])
     */
    getformatedMetalValues(item, type) {
      const result = this.getPairMetalValues(item, type);
      return `${result[0]} (${result[1]})`;
    },
    getImportedLargeValues(item) {
      const pieces = item.summary.metal.ILW
        + item.summary.metal.ILT
        + item.summary.metal.ILH
        + item.summary.metal.ILQ;
      const realPieces = item.summary.metal.ILW * 1
        + item.summary.metal.ILT * 0.75
        + item.summary.metal.ILH * 0.50
        + item.summary.metal.ILQ * 0.25;
      return [pieces, realPieces];
    },
    getImportedMediumValues(item) {
      const pieces = item.summary.metal.IMW
        + item.summary.metal.IMT
        + item.summary.metal.IMH
        + item.summary.metal.IMQ;
      const realPieces = item.summary.metal.IMW * 1
        + item.summary.metal.IMT * 0.75
        + item.summary.metal.IMH * 0.50
        + item.summary.metal.IMQ * 0.25;
      return [pieces, realPieces];
    },
    getImportedSmallValues(item) {
      const pieces = item.summary.metal.ISW
        + item.summary.metal.IST
        + item.summary.metal.ISH
        + item.summary.metal.ISQ;
      const realPieces = item.summary.metal.ISW * 1
        + item.summary.metal.IST * 0.75
        + item.summary.metal.ISH * 0.50
        + item.summary.metal.ISQ * 0.25;
      return [pieces, realPieces];
    },
    getLocalLargeValues(item) {
      const pieces = item.summary.metal.LLW
        + item.summary.metal.LLT
        + item.summary.metal.LLH
        + item.summary.metal.LLQ;
      const realPieces = item.summary.metal.LLW * 1
        + item.summary.metal.LLT * 0.75
        + item.summary.metal.LLH * 0.50
        + item.summary.metal.LLQ * 0.25;
      return [pieces, realPieces];
    },
    getLocalMediumValues(item) {
      const pieces = item.summary.metal.LMW
        + item.summary.metal.LMT
        + item.summary.metal.LMH
        + item.summary.metal.LMQ;
      const realPieces = item.summary.metal.LMW * 1
        + item.summary.metal.LMT * 0.75
        + item.summary.metal.LMH * 0.50
        + item.summary.metal.LMQ * 0.25;
      return [pieces, realPieces];
    },
    getLocalSmallValues(item) {
      const pieces = item.summary.metal.LSW
        + item.summary.metal.LST
        + item.summary.metal.LSH
        + item.summary.metal.LSQ;
      const realPieces = item.summary.metal.LSW * 1
        + item.summary.metal.LST * 0.75
        + item.summary.metal.LSH * 0.50
        + item.summary.metal.LSQ * 0.25;
      return [pieces, realPieces];
    },
    hasRole(roleName) {
      if (!this.$store.getters.getProfile.roles) {
        return false;
      }
      const found = this.$store.getters.getProfile.roles.filter((e) => {
        return roleName === e.name;
      });
      return found.length > 0;
    },
  },
  computed: {
    totals() {
      const initialValues = {
              material_expenses: 0.0,
              viatic_expenses: 0.0,
              comission_expenses: 0.0,
              pounds: 0.0,
              summary_catalyst_pieces: 0.0,
              summary_catalyst_real_pieces: 0.0,
              summary_top_tops: 0.0,
              summary_top_pieces_per_kilo: 0.0,
              il_metal: [0, 0], // getPairMetalValues(props.item, 'IL')
              im_metal: [0, 0], // getPairMetalValues(props.item, 'IM')
              is_metal: [0, 0], // getPairMetalValues(props.item, 'IS')
              ll_metal: [0, 0], // getPairMetalValues(props.item, 'LL')
              lm_metal: [0, 0], // getPairMetalValues(props.item, 'LM')
              ls_metal: [0, 0], // getPairMetalValues(props.item, 'LS')

              summary_catalyst_payed_price: 0.0,
              summary_catalyst_subtotal_prices: 0.0,
              summary_catalyst_subtotal_pesos_price: 0.0,
              summary_catalyst_subtotal_d_list_price: 0.0,
              summary_catalyst_subtotal_return_us: 0.0,
              summary_catalyst_subtotal_dollar_price: 0.0,

      };
      if (!this.routes || this.routes.length === 0) {
        return initialValues;
      } else {
        const results = Object.assign({}, initialValues);
        for (const line of this.routes) {
          results.material_expenses += parseFloat(line.material_expenses);
          results.viatic_expenses += parseFloat(line.viatic_expenses);
          results.comission_expenses += parseFloat(line.comission_expenses);
          results.pounds += parseFloat(line.pounds);

          if (line.summary.catalyst ) {
            results.summary_catalyst_pieces
              += parseInt(line.summary.catalyst.pieces, 10);
            results.summary_catalyst_real_pieces
              += parseFloat(line.summary.catalyst.real_pieces);
            results.summary_catalyst_payed_price
              += parseFloat(line.summary.catalyst.payed_price) || 0;
            results.summary_catalyst_subtotal_prices
              += parseFloat(line.summary.catalyst.subtotal_prices) || 0;
            results.summary_catalyst_subtotal_pesos_price
              += parseFloat(line.summary.catalyst.subtotal_pesos_price) || 0;
            results.summary_catalyst_subtotal_d_list_price
              += parseFloat(line.summary.catalyst.subtotal_d_list_price) || 0;
            results.summary_catalyst_subtotal_return_us
              += parseFloat(line.summary.catalyst.subtotal_return_us) || 0;
            results.summary_catalyst_subtotal_dollar_price
              += parseFloat(line.summary.catalyst.subtotal_dollar_price) || 0;
          }
          if (line.summary.top) {
            results.summary_top_tops += parseFloat(line.summary.top.tops);
            results.summary_top_pieces_per_kilo += parseFloat(line.summary.top.pieces_per_kilo);
          }

          results.il_metal[0] += parseFloat(this.getPairMetalValues(line, 'IL')[0]) || 0;
          results.il_metal[1] += parseFloat(this.getPairMetalValues(line, 'IL')[1]) || 0;
          results.im_metal[0] += parseFloat(this.getPairMetalValues(line, 'IM')[0]) || 0;
          results.im_metal[1] += parseFloat(this.getPairMetalValues(line, 'IM')[1]) || 0;
          results.is_metal[0] += parseFloat(this.getPairMetalValues(line, 'IS')[0]) || 0;
          results.is_metal[1] += parseFloat(this.getPairMetalValues(line, 'IS')[1]) || 0;
          results.ll_metal[0] += parseFloat(this.getPairMetalValues(line, 'LL')[0]) || 0;
          results.ll_metal[1] += parseFloat(this.getPairMetalValues(line, 'LL')[1]) || 0;
          results.lm_metal[0] += parseFloat(this.getPairMetalValues(line, 'LM')[0]) || 0;
          results.lm_metal[1] += parseFloat(this.getPairMetalValues(line, 'LM')[1]) || 0;
          results.ls_metal[0] += parseFloat(this.getPairMetalValues(line, 'LS')[0]) || 0;
          results.ls_metal[1] += parseFloat(this.getPairMetalValues(line, 'LS')[1]) || 0;
        }
        return results;
      }
    },
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.retrieveRoutesForCurrentBatch();
    this.retrieveCurrentBatch();
    if (!this.show_payed_price) {
      this.headers = this.headers.filter( (e) => e.text !== 'P. Pagado');
    }

    if (!this.show_metal_information) {
      this.headers = this.headers.filter( (e) => e.type !== 'metal');
    }

    if (!this.hasRole('SHOW_DOLLAR')) {
      this.headers = this.headers.filter( (e) => e.type !== 'dollar');
    }
  },
};
</script>